import React from "react";
import { humanizeUrl } from "@flogy/utils";
import { Link } from "@flogy/gatsby-theme-fgs-layout";
import useThemeOptions from "../../hooks/useThemeOptions";

const BlockSpan = ({ children }) => (
  <span style={{ display: "block" }}>{children}</span>
);

const optionalBlockSpan = (text) => text && <BlockSpan>{text}</BlockSpan>;

const AddressList = () => {
  const themeOptions = useThemeOptions();

  const impressumAddressBlocks = themeOptions.impressum.addresses.map(
    ({
      title,
      company,
      companyDescription,
      name,
      street,
      location,
      email,
      website,
      companyUid,
    }) => (
      <React.Fragment key={`${title}${company}`}>
        <h2>{title}</h2>
        <p>
          {optionalBlockSpan(company)}
          {optionalBlockSpan(companyDescription)}
          {optionalBlockSpan(name)}
          {optionalBlockSpan(street)}
          {optionalBlockSpan(location)}
          {email && <Link href={`mailto:${email}`}>{email}</Link>}
          {website && <Link href={website}>{humanizeUrl(website)}</Link>}
        </p>
        {companyUid && <p>UID: {companyUid}</p>}
      </React.Fragment>
    )
  );

  return impressumAddressBlocks;
};

export default AddressList;
